import React from 'react'
import type { PurchaseOrderStatusEnum } from '@ztechapps/common.contract'
import { PurchaseOrderStatus as PurchaseOrderStatusEntries } from '@ztechapps/purchase-order.common'
import { StatusColorBadge, StatusColorDot, findStatus } from '@ztechapps/webui.util'

export type PurchaseOrderStatusProps = { status: string }

export const PurchaseOrderStatus = ({ status }: PurchaseOrderStatusProps) => (
  <StatusColorDot value={status} color={findStatus(PurchaseOrderStatusEntries, status)} />
)

export const PurchaseOrderStatusBadge = ({ status }: { status: PurchaseOrderStatusEnum }) => (
  <StatusColorBadge status={status} color={findStatus(PurchaseOrderStatusEntries, status)} />
)
